// Parent side of the business detail iframe protocol (nextDetailBridge=v1).
export const DETAIL_TIMEOUT_MS = 60000
const MAX_PENDING = 4
const MAX_PARAMS_BYTES = 65536
const OPERATIONS = ['list', 'audio', 'translate']

export function createDetailBridge({ origin, page, getWindow, onState, query, receive, timer = setTimeout, cancelTimer = clearTimeout }) {
  let closed = false
  const pending = new Set()
  let timeout
  const armTimeout = () => {
    if (timeout !== undefined) cancelTimer(timeout)
    timeout = timer(() => { if (!closed) onState('error') }, DETAIL_TIMEOUT_MS)
  }
  armTimeout()
  const listener = async event => {
    if (closed || event.origin !== origin || event.source !== getWindow()) return
    const data = event.data
    if (!data || typeof data !== 'object') return
    if (data.type === 'next-business-page-state' && data.page === page && ['ready', 'loading', 'error'].includes(data.status)) {
      onState(data.status)
      if (data.status === 'loading') armTimeout()
      else cancelTimer(timeout)
      return
    }
    if (page !== 'talk-detail' || data.type !== 'next-talk-request' || typeof data.id !== 'string' || !/^[a-z0-9-]{1,64}$/.test(data.id)) return
    if (!OPERATIONS.includes(data.operation) || !data.params || typeof data.params !== 'object' || Array.isArray(data.params)) return
    if (pending.size >= MAX_PENDING || pending.has(data.id)) return
    let size
    try { size = JSON.stringify(data.params).length } catch { return }
    if (size > MAX_PARAMS_BYTES) return
    const target = getWindow()
    pending.add(data.id)
    try {
      const result = await query({ operation: data.operation, params: data.params })
      if (!closed && target === getWindow()) target.postMessage({ type: 'next-talk-response', id: data.id, ok: true, data: result }, origin)
    } catch (error) {
      if (!closed && target === getWindow()) target.postMessage({ type: 'next-talk-response', id: data.id, ok: false, status: error?.status || 502, message: 'Unable to read this Talk Detail record.' }, origin)
    } finally { pending.delete(data.id) }
  }
  receive.addEventListener('message', listener)
  return () => {
    closed = true
    cancelTimer(timeout)
    receive.removeEventListener('message', listener)
  }
}

export function accessTokenFromCookie(cookie) {
  const row = String(cookie || '').split('; ').find(x => x.startsWith('access_token='))
  return row ? decodeURIComponent(row.slice('access_token='.length)) : undefined
}

export async function queryTalk(request, { token, fetchImpl = fetch }) {
  if (!token) throw new Error('Sign in required')
  const res = await fetchImpl('/api/robot-business/talk', {
    method: 'POST',
    credentials: 'omit',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
    body: JSON.stringify(request)
  })
  if (!res.ok) throw Object.assign(new Error('Talk Detail request failed'), { status: res.status })
  return res.json()
}
